import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

export interface ExitDialogData {
 title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  icon?: string;}

@Component({
  selector: 'app-exit-comfirm-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatIconModule,      
    MatButtonModule   ],  
  templateUrl: './exit-confirm-dialog.component.html',
  styleUrl: './exit-confirm-dialog.component.scss'
})
export class ExitConfirmDialogComponent {
 constructor(
    private dialogRef: MatDialogRef<ExitConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ExitDialogData
  ) {}

  close(result: boolean): void {
    this.dialogRef.close(result);
  }
}
